import { Link } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { APIENDPOINT } from "../services/apiHelper";
import { getFormEntriesByFormName } from "../services/formServices";
import toast from "react-hot-toast";
import { FORMNAMES } from "../utilities/codes";
import { schoolContext } from "../contexts/SchoolContextProvider";
import { AnimatePresence, motion } from "framer-motion";
import { mediaSource, useBackgroundImage } from "../utilities/mediautilities";
import { FaArrowRight, FaBriefcase, FaGraduationCap, FaStopwatch, FaTrophy } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { I18N_KEYS } from "../languages/PlaceHolder.js";

const Teachers = () => {
    const [selectedTeacher, setSelectedTeacher] = useState(null);
    const [teachers, setTeachers] = useState([]);
    const { schoolDetails } = useContext(schoolContext);
    const { t } = useTranslation();
    const bgUrl = useBackgroundImage(schoolDetails?.dignataries?.fileUrl);

    // Dummy data for top teachers
    // const dummyTeachers = [
    //     {
    //         payload: {
    //             teacher_name: "Dr. Meera Krishnan",
    //             subject: "Mathematics",
    //             experience: "15 Years",
    //             qualification: "Ph.D. in Mathematics",
    //             specialization: "Advanced Calculus & Algebra",
    //             achievement: "Best Teacher Award 2023",
    //             description: "Dr. Meera has been instrumental in shaping the mathematical foundation of thousands of students. Her innovative teaching methods have helped students excel in competitive examinations.",
    //             email: "meera.krishnan@school.edu"
    //         }
    //     },
    //     {
    //         payload: {
    //             teacher_name: "Prof. Rajesh Malhotra",
    //             subject: "Physics",
    //             experience: "18 Years",
    //             qualification: "M.Sc. Physics, B.Ed.",
    //             specialization: "Quantum Mechanics & Optics",
    //             achievement: "State Level Excellence Award",
    //             description: "Prof. Rajesh brings complex physics concepts to life through practical demonstrations and real-world applications. His students consistently perform well in JEE and NEET examinations.",
    //             email: "rajesh.malhotra@school.edu"
    //         }
    //     },
    //     {
    //         payload: {
    //             teacher_name: "Ms. Anjali Desai",
    //             subject: "Chemistry",
    //             experience: "12 Years",
    //             qualification: "M.Sc. Chemistry, Ph.D. (Pursuing)",
    //             specialization: "Organic & Inorganic Chemistry",
    //             achievement: "Innovative Teaching Methodology Award",
    //             description: "Ms. Anjali's passion for chemistry is infectious. She uses interactive lab sessions and modern teaching tools to make chemistry engaging and understandable for all students.",
    //             email: "anjali.desai@school.edu"
    //         }
    //     },
    //     {
    //         payload: {
    //             teacher_name: "Dr. Vikram Singh",
    //             subject: "Biology",
    //             experience: "20 Years",
    //             qualification: "M.B.B.S., M.Sc. Biology",
    //             specialization: "Human Anatomy & Physiology",
    //             achievement: "Outstanding Educator Award",
    //             description: "Dr. Vikram combines his medical background with teaching expertise to provide students with deep insights into biological sciences. Many of his students have successfully pursued careers in medicine.",
    //             email: "vikram.singh@school.edu"
    //         }
    //     },
    //     {
    //         payload: {
    //             teacher_name: "Mrs. Priya Nair",
    //             subject: "English Literature",
    //             experience: "14 Years",
    //             qualification: "M.A. English, M.Phil.",
    //             specialization: "Shakespeare & Modern Literature",
    //             achievement: "Literary Excellence Award",
    //             description: "Mrs. Priya's classes are known for their engaging discussions and critical analysis. She has inspired many students to pursue careers in literature and journalism.",
    //             email: "priya.nair@school.edu"
    //         }
    //     },
    //     {
    //         payload: {
    //             teacher_name: "Mr. Suresh Kumar",
    //             subject: "Computer Science",
    //             experience: "10 Years",
    //             qualification: "M.Tech. Computer Science",
    //             specialization: "Programming & Data Structures",
    //             achievement: "Tech Innovation Award",
    //             description: "Mr. Suresh stays updated with the latest technology trends and ensures students learn cutting-edge programming skills. His students have won multiple coding competitions.",
    //             email: "suresh.kumar@school.edu"
    //         }
    //     },
    //     {
    //         payload: {
    //             teacher_name: "Dr. Kavita Sharma",
    //             subject: "History",
    //             experience: "16 Years",
    //             qualification: "Ph.D. in History",
    //             specialization: "Ancient & Medieval History",
    //             achievement: "Excellence in Teaching Award",
    //             description: "Dr. Kavita makes history come alive through storytelling and interactive sessions. Her students develop a deep appreciation for historical events and their impact on modern society.",
    //             email: "kavita.sharma@school.edu"
    //         }
    //     },
    //     {
    //         payload: {
    //             teacher_name: "Mr. Amit Patel",
    //             subject: "Geography",
    //             experience: "13 Years",
    //             qualification: "M.Sc. Geography, B.Ed.",
    //             specialization: "Physical & Human Geography",
    //             achievement: "Innovative Educator Award",
    //             description: "Mr. Amit uses maps, models, and field trips to make geography engaging. His teaching methods help students understand the world around them better.",
    //             email: "amit.patel@school.edu"
    //         }
    //     },
    //     {
    //         payload: {
    //             teacher_name: "Ms. Radha Menon",
    //             subject: "Economics",
    //             experience: "11 Years",
    //             qualification: "M.A. Economics, M.Phil.",
    //             specialization: "Micro & Macro Economics",
    //             achievement: "Academic Excellence Award",
    //             description: "Ms. Radha simplifies complex economic concepts and connects them to real-world scenarios. Her students excel in competitive exams and develop strong analytical skills.",
    //             email: "radha.menon@school.edu"
    //         }
    //     },
    //     {
    //         payload: {
    //             teacher_name: "Dr. Ramesh Iyer",
    //             subject: "Hindi",
    //             experience: "17 Years",
    //             qualification: "Ph.D. in Hindi Literature",
    //             specialization: "Classical & Modern Hindi",
    //             achievement: "Language Excellence Award",
    //             description: "Dr. Ramesh is passionate about Hindi literature and language. He inspires students to appreciate the richness of Hindi literature and culture.",
    //             email: "ramesh.iyer@school.edu"
    //         }
    //     }
    // ];

    useEffect(() => {
        getTopTeachers();
    }, []);

    const getTopTeachers = async () => {
        try {
            const filters = { staff_role: { operator: "equals", value: "Teacher" } }
            const response = await getFormEntriesByFormName(FORMNAMES.STAFFINFORMATION, filters);
            if (response && response.length > 0) {
                setTeachers(response);
            }
        } catch (error) {
            toast.error(error.message);
        }
    };

    return (
        <>
            <section
                className="relative bg-cover bg-center py-20 px-6 mb-10"
                style={{ backgroundImage: `url(${bgUrl})` }}
            >
                <div className="absolute inset-0 bg-black/50"></div>
                <div className="relative z-10 common-container">
                    <div className="rounded-lg text-left">
                        <h1 className="text-4xl md:text-5xl font-bold mb-4 text-accent">
                            {t(I18N_KEYS.TOPTEACHERPAGENAME)}
                        </h1>
                        <p className="text-lg md:text-xl text-accent">
                            <Link to="/" className="hover:text-primary">
                                {t(I18N_KEYS.HOMEPAGENAME)}
                            </Link>{" "}
                            &gt; {t(I18N_KEYS.TOPTEACHERPAGENAME)}
                        </p>
                    </div>
                </div>
            </section>

            <section className="py-12 md:py-16 px-4 md:px-6 bg-gray-50">
                <div className="max-w-7xl mx-auto">
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 mb-8 common-container">
                        {teachers?.map((teacher, index) => (
                            <motion.div
                                key={index}
                                initial={{ opacity: 0, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ duration: 0.5, delay: index * 0.1 }}
                                whileHover={{ y: -5 }}
                                className="group cursor-pointer"
                                onClick={() => setSelectedTeacher(teacher)}
                            >
                                {/* Teacher Card */}
                                <div className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-xl transition-all duration-300 h-full flex flex-col border border-gray-100">
                                    {/* Image Section */}
                                    <div className="relative h-56 bg-gradient-to-br from-primary/10 to-secondary/10 overflow-hidden">
                                        <img
                                            src={mediaSource(teacher?.payload?.profile_photo?.fileUrl)}
                                            alt={teacher?.payload?.teacher_name || "Teacher"}
                                            onError={(e) => mediaSource(e)}
                                            className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                                        />
                                        {/* Gradient Overlay */}
                                        <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>

                                        {/* Subject Badge */}
                                        {teacher?.payload?.subjects_assigned1_ref.length > 0 && (
                                            <div className="absolute top-4 left-4">
                                                <span className="px-3 py-1.5 bg-primary text-accent text-sm font-semibold rounded-full shadow-lg">
                                                    {teacher?.payload?.subjects_assigned1_ref[0]?.name}
                                                </span>
                                            </div>
                                        )}

                                        {/* Achievement Badge */}
                                        {teacher?.payload?.achievement && (
                                            <div className="absolute top-4 right-4 text-primary">
                                                <div className="px-3 py-1.5 bg-secondary/90 text-accent text-xs font-semibold rounded-full shadow-lg flex items-center gap-1">
                                                    <span><FaTrophy /></span>
                                                    <span className="hidden sm:inline">{teacher?.payload?.achievement}</span>
                                                </div>
                                            </div>
                                        )}
                                    </div>

                                    {/* Content Section */}
                                    <div className="p-5 flex-1 flex flex-col">
                                        {/* Name */}
                                        {teacher?.payload?.full_name && (
                                            <h3 className="text-lg font-bold text-gray-800 mb-2 group-hover:text-primary transition-colors">
                                                {teacher?.payload?.full_name}
                                            </h3>
                                        )}

                                        {/* Quick Info */}
                                        <div className="space-y-2 mb-4 flex-1">
                                            {teacher?.payload?.qualification && (
                                                <div className="flex items-center gap-2 text-gray-600 text-sm">
                                                    <span className="text-base"><FaGraduationCap /></span>
                                                    <span className="line-clamp-1">{teacher?.payload?.qualification.split(',')[0]}</span>
                                                </div>
                                            )}
                                            {teacher?.payload?.experience && (
                                                <div className="flex items-center gap-2 text-gray-600 text-sm">
                                                    <span className="text-base"><FaBriefcase /></span>
                                                    <span>{teacher?.payload?.experience} {t(I18N_KEYS.TEACHEREXP)}</span>
                                                </div>
                                            )}
                                        </div>

                                        {/* Specialization */}
                                        {teacher?.payload?.specialization && (
                                            <div className="mb-4">
                                                <p className="text-xs text-gray-500 uppercase tracking-wide mb-1">{t(I18N_KEYS.TEACHERSPECIALIZATION)}</p>
                                                <p className="text-sm text-primary font-medium line-clamp-2">
                                                    {teacher?.payload?.specialization}
                                                </p>
                                            </div>
                                        )}

                                        {/* View Profile Link */}
                                        <div className="mt-auto pt-3 border-t border-gray-100">
                                            <span className="text-primary text-sm font-semibold hover:underline flex items-center gap-1">
                                                {t(I18N_KEYS.VIEWPROFILE)}
                                                <span><FaArrowRight /></span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </motion.div>
                        ))}
                    </div>
                </div>

                {/* Modal for detailed view */}
                <AnimatePresence>
                    {selectedTeacher && (
                        <motion.div
                            className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4"
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            onClick={() => setSelectedTeacher(null)}
                        >
                            <button
                                onClick={() => setSelectedTeacher(null)}
                                className="absolute top-4 right-4 text-accent text-3xl font-bold hover:text-primary z-10 w-12 h-12 flex items-center justify-center bg-black/50 rounded-full hover:bg-black/70 transition-colors"
                            >
                                &times;
                            </button>
                            <motion.div
                                className="bg-accent rounded-3xl overflow-hidden shadow-2xl max-w-3xl w-full max-h-[90vh] overflow-y-auto"
                                initial={{ scale: 0.8, y: 40 }}
                                animate={{ scale: 1, y: 0 }}
                                exit={{ scale: 0.8, y: 40 }}
                                transition={{ duration: 0.3 }}
                                onClick={(e) => e.stopPropagation()}
                            >
                                <div className="p-8 md:p-12">
                                    <div className="flex justify-center mb-8">
                                        <div className="relative w-48 h-48 md:w-64 md:h-64">
                                            <div className="absolute inset-0 bg-gradient-to-br from-primary via-secondary to-primary rounded-full p-1">
                                                <div className="w-full h-full bg-accent rounded-full overflow-hidden border-4 border-accent">
                                                    <img
                                                        src={mediaSource(selectedTeacher?.payload?.profile_photo?.fileUrl)}
                                                        alt={selectedTeacher?.payload?.teacher_name || "Teacher"}
                                                        className="w-full h-full object-cover"
                                                        onError={(e) => mediaSource(e)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="text-center">
                                        {selectedTeacher?.payload?.full_name && (
                                            <h3 className="text-3xl md:text-4xl font-bold mb-3 text-gray-800">
                                                {selectedTeacher?.payload?.full_name}
                                            </h3>
                                        )}
                                        {selectedTeacher?.payload?.subject && (
                                            <div className="inline-flex items-center gap-2 px-6 py-2 bg-primary/10 rounded-full mb-6">
                                                <span className="text-primary font-semibold text-lg">
                                                    {selectedTeacher?.payload?.subject}
                                                </span>
                                            </div>
                                        )}
                                        <div className="grid md:grid-cols-2 gap-6 mb-8">
                                            {selectedTeacher?.payload?.qualification && (
                                                <div className="bg-gray-50 rounded-xl p-4">
                                                    <div className="flex items-center gap-3 mb-2">
                                                        <span className="text-2xl"><FaGraduationCap /></span>
                                                        <h4 className="font-semibold text-gray-700">{t(I18N_KEYS.TEACHERQUALIFICATION)}</h4>
                                                    </div>
                                                    <p className="text-gray-600">{selectedTeacher?.payload?.qualification}</p>
                                                </div>
                                            )}
                                            {selectedTeacher?.payload?.experience && (
                                                <div className="bg-gray-50 rounded-xl p-4">
                                                    <div className="flex items-center gap-3 mb-2">
                                                        <span className="text-2xl"><FaBriefcase /></span>
                                                        <h4 className="font-semibold text-gray-700">{t(I18N_KEYS.TEACHEREXP)}</h4>
                                                    </div>
                                                    <p className="text-gray-600">{selectedTeacher?.payload?.experience}</p>
                                                </div>
                                            )}
                                        </div>
                                        {selectedTeacher?.payload?.about_staff && (
                                            <div className="bg-primary/5 rounded-xl p-6 mb-6">
                                                <h4 className="font-semibold text-primary mb-3 text-left">{t(I18N_KEYS.ABOUT)}</h4>
                                                <p className="text-gray-700 leading-relaxed text-left"
                                                    dangerouslySetInnerHTML={{
                                                        __html: selectedTeacher?.payload?.about_staff
                                                    }}
                                                >
                                                </p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </motion.div>
                        </motion.div>
                    )}
                </AnimatePresence>
            </section>
        </>
    );
}
export default Teachers;